export { default } from './Checkbox.react';



// WEBPACK FOOTER //
// ./node_modules/react-native-material-ui/src/Checkbox/index.js